import { resolveImage } from "../components/admin/ImageUpload";

// Luminance thresholds (0-255). Backend measures each uploaded logo and returns
// `<field>_lum`, so we can tell a white logo from a navy one and keep it readable.
const LIGHT_MIN = 150;
const DARK_MAX = 170;

export const DEFAULT_HEADER_LOGO_HEIGHT = 72;
export const DEFAULT_FOOTER_LOGO_HEIGHT = 72;

/**
 * Resolve the logo to render for a given slot.
 * @param {object} s   site settings
 * @param {object} opts { place: "header" | "footer", onDark: boolean }
 * @returns {{ src: string, filterClass: string, height: number }}
 */
export const pickLogo = (s = {}, { place = "header", onDark = false } = {}) => {
  const dark = place === "footer" ? true : onDark;
  const lum = {};
  const remember = (u, l) => { if (u) lum[u] = l; };
  remember(s.header_logo_url, s.header_logo_url_lum);
  remember(s.header_logo_light_url, s.header_logo_light_url_lum);
  remember(s.footer_logo_url, s.footer_logo_url_lum);
  remember(s.logo_url, s.logo_url_lum);
  remember(s.logo_dark_url, s.logo_dark_url_lum);

  const pref = place === "footer"
    ? [s.footer_logo_url, s.header_logo_light_url, s.logo_dark_url, s.header_logo_url, s.logo_url]
    : dark
      ? [s.header_logo_light_url, s.logo_dark_url, s.header_logo_url, s.logo_url]
      : [s.header_logo_url, s.logo_url, s.header_logo_light_url, s.logo_dark_url];

  const list = pref.filter(Boolean);
  const fits = (u) => {
    const l = lum[u];
    if (l === undefined || l === null) return null;
    return dark ? l >= LIGHT_MIN : l <= DARK_MAX;
  };

  const src = list.find((u) => fits(u) === true) || list[0] || "";
  const needsFilter = src ? fits(src) === false : false;
  const rawHeight = place === "footer" ? s.footer_logo_height : s.header_logo_height;
  const fallbackHeight = place === "footer" ? DEFAULT_FOOTER_LOGO_HEIGHT : DEFAULT_HEADER_LOGO_HEIGHT;

  return {
    src: resolveImage(src),
    filterClass: needsFilter ? (dark ? "brightness-0 invert" : "brightness-0") : "",
    height: Number(rawHeight) > 0 ? Number(rawHeight) : fallbackHeight,
  };
};
